import React from 'react';

import { UiTypography } from '@/components/ui/Typography';

import {
  OptionIconStyles,
  OptionListStyles,
  OptionStyles,
} from './Option.styles';

export const OptionList: React.FC<{
  children: NonNullable<React.ReactNode>;
}> = ({ children }) => {
  return (
    <OptionListStyles className="options-list">{children}</OptionListStyles>
  );
};

export const Option: React.FC<{
  title: string;
  subtitle: string;
  emoji: string;
  isSelected: boolean;
  onClick: () => void;
}> = ({ title, subtitle, emoji, isSelected, onClick }) => {
  return (
    <OptionStyles
      onClick={onClick}
      isSelected={isSelected}
      className="option"
      role="button"
    >
      <div className="option-content">
        <UiTypography variant={'title-small'} className="option-title">
          {title}
        </UiTypography>
        <UiTypography
          variant={'body-medium'}
          color={'neutral-white'}
          className="option-subtitle"
        >
          {subtitle}
        </UiTypography>
      </div>

      <OptionIconStyles>
        <span className="emoji">{emoji}</span>
      </OptionIconStyles>
    </OptionStyles>
  );
};
